import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.tsx';
import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.tsx';
import { ItemCard, ItemCardBody, ItemCardMeta, ItemCardSection, ItemCardSummary } from '@sola/ark-core/molecules/item-card/item-card.tsx';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { useAuth } from '@sola/auth-sdk/store.tsx';
import '@sola/locales/formatters.ts';
import type { TaxReceipt } from '@sola/schema/dotcom/proxy-api/taxReceipts.ts';
import { CommitmentAvatarWrapper } from '../../atoms/commitment-avatar/commitment-avatar.tsx';
export type TaxReceiptCardProps = {
  isLoading: true;
  taxReceipt?: TaxReceipt;
} | {
  isLoading?: false;
  taxReceipt: TaxReceipt;
};

/**
 * Tax Receipt card
 */
export const TaxReceiptCard: React.FC<TaxReceiptCardProps> = t0 => {
  const $ = _c(10);
  const {
    isLoading,
    taxReceipt
  } = t0;
  const {
    t
  } = useTranslation("my");
  const {
    authUser
  } = useAuth("authUser");
  let t1;
  if ($[0] !== isLoading) {
    t1 = isLoading && <Skeleton height={100} />;
    $[0] = isLoading;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== authUser || $[3] !== isLoading || $[4] !== t || $[5] !== taxReceipt) {
    t2 = !isLoading && <ItemCard><ItemCardSection><ItemCardBody><ItemCardSummary icon={<CommitmentAvatarWrapper responsive={true}><ArkIcon iconName="receipt-check" /></CommitmentAvatarWrapper>} title={t("taxReceipts.cardTitle", {
            year: taxReceipt?.year
          })} /><ItemCardMeta><ButtonStyle iconAfter={<ArkIcon iconName="download-01" />} variant="secondary" size="md"><button type="button" onClick={() => {
                if (!authUser?.authUserGlobalId || !taxReceipt?.year) {
                  return;
                }
                const supporterId = encodeURIComponent(authUser.authUserGlobalId);
                const taxReceiptYear = encodeURIComponent(taxReceipt.year.toString());
                const taxReceiptUrl = `${process.env.NEXT_PUBLIC_BASE_URL_PROXY_API}/supporters/${supporterId}/tax-receipts/${taxReceiptYear}`;
                window.open(taxReceiptUrl, "_blank", "noopener,noreferrer");
              }}>{t("taxReceipts.download")}</button></ButtonStyle></ItemCardMeta></ItemCardBody></ItemCardSection></ItemCard>;
    $[2] = authUser;
    $[3] = isLoading;
    $[4] = t;
    $[5] = taxReceipt;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};